import qrcode from "qrcode-generator";
import {ZERO, CLASS_NAME_INVISIBLE} from '../constants';
import axios from "../../axios-instance";
import {createFormData} from './form-data-helper';

const mfaCodeMinimalLength = 4;
const saveUserAndMFAURI = '/user_login/init_user_with_mfa';

const mfaShowError = (mfaErrorElement, mfaErrorText, mfaCompleteButton) => {
  mfaErrorElement.textContent = mfaErrorText;
  mfaErrorElement.classList.remove('invisible');
  mfaCompleteButton.classList.remove('disabled');
}

const mfaHideError = (mfaErrorElement, mfaCompleteButton) => {
  mfaErrorElement.classList.add('invisible');
  mfaCompleteButton.classList.add('disabled');
}

const mfaQrcodeDraw = (qrText) => {
  const qr = qrcode(ZERO, 'L');
  qr.addData(qrText);
  qr.make();
  document.querySelector('.js-mfa-qrcode-image').innerHTML = qr.createImgTag();
};

const mfaSecretKeySet = (secretKey) => {
  document.querySelector('.js-mfa-secret-key input').value = secretKey;
}

const mfaGetSecretFromUrl = (url) => {
  const urlSplit = url.split('?');
  const urlSearchParams = new URLSearchParams(urlSplit[1]);
  const params = Object.fromEntries(urlSearchParams.entries());
  return params.secret;
}

const mfaCheckCodeLength = (mfaCode, disableButton, buttonCanBeActive = true) => {
  const mfaCodeLength = mfaCode.value.length;
  if (mfaCodeLength >= mfaCodeMinimalLength && buttonCanBeActive) {
    disableButton.classList.remove('disabled');
  } else {
    disableButton.classList.add('disabled');
  }
}

const mfaDataSave = (userData, modalDialog, uri = saveUserAndMFAURI) => {
  userData['mfa_save_only'] = true;
  const mfaError = document.querySelector('.js-mfa-complete-error');
  const mfaCompleteButton = document.querySelector('.js-mfa-complete-button');
  mfaHideError(mfaError, mfaCompleteButton);
  axios
      .post(uri, createFormData(userData))
      .then(response => {
        if (response.data.is_error) {
          mfaShowError(mfaError, response.data.errors.mfa_save, mfaCompleteButton);
        } else {
          modalDialog.destroyModalBox();
          document.location.href = '/';
        }
      });
}

const mfaToggle = () => {
  const mfaSecretKey = document.querySelector('.js-mfa-secret-key');
  const mfaSecretKeySummary = document.querySelector('.js-mfa-secret-key-summary');
  const mfaQrcodeSummary = document.querySelector('.js-mfa-qrcode-summary');
  if (mfaSecretKey.classList.contains(CLASS_NAME_INVISIBLE)) {
    mfaSecretKey.classList.remove(CLASS_NAME_INVISIBLE);
    mfaSecretKeySummary.classList.remove(CLASS_NAME_INVISIBLE);
    mfaQrcodeSummary.classList.add(CLASS_NAME_INVISIBLE);
  } else {
    mfaSecretKey.classList.add(CLASS_NAME_INVISIBLE);
    mfaSecretKeySummary.classList.add(CLASS_NAME_INVISIBLE);
    mfaQrcodeSummary.classList.remove(CLASS_NAME_INVISIBLE);
  }
}

const mfaQrcodeGenerate = () => {
  const promise = axios.post('/mfa/generate_secret_key')
  const outputPromise = promise.then((response) => {
    const secretKey = mfaGetSecretFromUrl(response.data.qrCodeText);
    mfaQrcodeDraw(response.data.qrCodeText);
    mfaSecretKeySet(secretKey);
    return response;
  });
  return outputPromise;

};

const initMfaToggle = () => {
  const mfaToggles = document.querySelectorAll('.js-mfa-toggle');
  if (mfaToggles.length > 0) {
    mfaToggles.forEach(el => {
      el.addEventListener('click', event => {
        mfaToggle();
      });
    })
  }
}

export {
  mfaShowError,
  mfaHideError,
  mfaQrcodeDraw,
  mfaSecretKeySet,
  mfaGetSecretFromUrl,
  mfaCheckCodeLength,
  mfaDataSave,
  mfaToggle,
  mfaQrcodeGenerate,
  initMfaToggle
};
